import axios from "axios";

// Action Types
export const FETCH_EBT_DRS_CONSUMERS_REQUEST = "FETCH_EBT_DRS_CONSUMERS_REQUEST";
export const FETCH_EBT_DRS_CONSUMERS_SUCCESS = "FETCH_EBT_DRS_CONSUMERS_SUCCESS";
export const FETCH_EBT_DRS_CONSUMERS_FAILURE = "FETCH_EBT_DRS_CONSUMERS_FAILURE";
export const SEND_EBT_REQUEST = "SEND_EBT_REQUEST";
export const SEND_EBT_SUCCESS = "SEND_EBT_SUCCESS";
export const SEND_EBT_FAILURE = "SEND_EBT_FAILURE";
export const SEND_EBT_DEREGISTRATION_REQUEST = "SEND_EBT_DEREGISTRATION_REQUEST";
export const SEND_EBT_DEREGISTRATION_SUCCESS = "SEND_EBT_DEREGISTRATION_SUCCESS";
export const SEND_EBT_DEREGISTRATION_FAILURE = "SEND_EBT_DEREGISTRATION_FAILURE";

// Action Creators
export const fetchEbtDrsConsumersRequest = () => ({
  type: FETCH_EBT_DRS_CONSUMERS_REQUEST,
});

export const fetchEbtDrsConsumersSuccess = (data, total) => ({
  type: FETCH_EBT_DRS_CONSUMERS_SUCCESS,
  payload: {
    data,
    total
  }
});

export const fetchEbtDrsConsumersFailure = (error) => ({
  type: FETCH_EBT_DRS_CONSUMERS_FAILURE,
  payload: error
});

export const sendEbtRequest = () => ({
  type: SEND_EBT_REQUEST,
});

export const sendEbtSuccess = (transactionId) => ({
  type: SEND_EBT_SUCCESS,
  payload: {
    transactionId
  }
});

export const sendEbtFailure = (error) => ({
  type: SEND_EBT_FAILURE,
  payload: error
});

export const sendEbtDeregistrationRequest = () => ({
  type: SEND_EBT_DEREGISTRATION_REQUEST,
});

export const sendEbtDeregistrationSuccess = (transactionId) => ({
  type: SEND_EBT_DEREGISTRATION_SUCCESS,
  payload: {
    transactionId
  }
});

export const sendEbtDeregistrationFailure = (error) => ({
  type: SEND_EBT_DEREGISTRATION_FAILURE,
  payload: error
});

// Action Creator for sending termination
export const sendEbtTerminationRequest = () => ({
  type: SEND_EBT_DEREGISTRATION_REQUEST, // Reusing the same type as deregistration for simplicity
});

export const sendEbtTerminationSuccess = (transactionId) => ({
  type: SEND_EBT_DEREGISTRATION_SUCCESS, // Reusing the same type as deregistration for simplicity
  payload: {
    transactionId
  }
});

export const sendEbtTerminationFailure = (error) => ({
  type: SEND_EBT_DEREGISTRATION_FAILURE, // Reusing the same type as deregistration for simplicity
  payload: error
});

// Thunk Action Creator
export const fetchEbtDrsConsumers = (query) => {
  return async (dispatch) => {
    dispatch(fetchEbtDrsConsumersRequest());
    try {
      const response = await axios.get(`/ebt_drs_consumers${query}`);
      dispatch(fetchEbtDrsConsumersSuccess(response.data.data, response.data.total));
    } catch (error) {
      dispatch(fetchEbtDrsConsumersFailure(error.message));
    }
  };
};

// Thunk Action Creator for sending EBT
export const sendEbt = (id, date, type) => {
  return async (dispatch) => {
    dispatch(sendEbtRequest());
    try {
      const response = await axios.post(`/ebt_drs_consumers/${id}/send_ebt`, { date, type });
      dispatch(sendEbtSuccess(response.data.transactionId));
      return response.data;
    } catch (error) {
      dispatch(sendEbtFailure(error.message));
      throw error;
    }
  };
};

// Thunk Action Creator for sending EBT deregistration
export const sendEbtDeregistration = (id, date) => {
  return async (dispatch) => {
    dispatch(sendEbtDeregistrationRequest());
    try {
      const response = await axios.post(`/ebt_drs_consumers/${id}/send_ebt_deregistration`, { date });
      dispatch(sendEbtDeregistrationSuccess(response.data.transactionId));
      return response.data;
    } catch (error) {
      dispatch(sendEbtDeregistrationFailure(error.message));
      throw error;
    }
  };
};

// Thunk Action Creator for sending EBT termination
export const sendEbtTermination = (id, date) => {
  return async (dispatch) => {
    dispatch(sendEbtTerminationRequest());
    try {
      const response = await axios.post(`/ebt_drs_consumers/${id}/send_termination`, { date });
      dispatch(sendEbtTerminationSuccess(response.data.transactionId));
      return response.data;
    } catch (error) {
      dispatch(sendEbtTerminationFailure(error.message));
      throw error;
    }
  };
};
